module.exports = __webpack_public_path__ + "static/media/badge_tiyu.efe5f693.svg";